(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var Menu = module.exports = function () {

    $('.burger-wrapper').on('click', function (e) {
        if (!$('body').hasClass('menu-open')) {
            $('body').addClass('menu-open');
        } else {
            $('body').removeClass('menu-open');
            setTimeout(function () {
                this.reset();
            }.bind(this), 500);
        }
    }.bind(this));


    /*Constructor Menu Mobile*/
    this.reset();

    $('#menu #navigation-menu li').on('click', function (e) {

        if ($('body').hasClass('menu-open')) {
            if ($(e.currentTarget).hasClass('header')) {
                //Back !
                this.clean();
                this.ul_current.addClass('animate-outToRight');

                this.ul_current = $(e.currentTarget).closest('ul').parent().closest('ul');

                this.ul_current.addClass('current animate-inFromLeft');
                if (this.ul_current.hasClass('nav-level-0')){
                    $('#menu').addClass('root');
                }else{
                    $('#menu').removeClass('root');
                }

                $('#navigation-menu > nav').css('height', this.ul_current.innerHeight());
                e.preventDefault();
                return false;

            } else {


                if ($(e.currentTarget).find('ul').length > 0) {
                    this.clean();
                    this.ul_current.addClass('animate-outToLeft');
                    this.ul_current = $(e.currentTarget).find('ul').first();

                    this.ul_current.addClass('current animate-inFromRight');
                    $('#navigation-menu > nav').css('height', this.ul_current.innerHeight());

                    if (this.ul_current.hasClass('nav-level-0')){
                        $('#menu').addClass('root');
                    }else{
                        $('#menu').removeClass('root');
                    }

                    e.preventDefault();
                    return false;
                } else {
                    window.location = ($(e.currentTarget).find('> a').attr('href'));
                }
            }
        }


    }.bind(this));


    /*Constructor Menu Desktop*/
    $('#navigation-menu > nav > ul.nav-level-0 > li > a').each(function (index, a) {
        if ($(a).parent().find('> ul').length > 0) {
            $(a).on('click', function (e) {
                if (!$('body').hasClass('menu-open')) {
                    if (!$(a).parent().hasClass('open')) {
                        this.open(index);
                    } else {
                        this.close();
                    }
                    e.preventDefault();
                    return false;
                }
            }.bind(this));

        }

    }.bind(this));

    $(document).on('click', function (e) {
        if (!$(e.target).parents('#navigation-menu').length && this.is_open) {
            this.close();
        }

        if ($(e.target).hasClass('menu-open')){
            this.reset();
        }
    }.bind(this));

    window.addEventListener("breakpoint", function (e) {
        //e.detail
        this.close();
        this.reset();

    }.bind(this));


}


/*Clean Menu Mobile*/
Menu.prototype.reset = function () {
    $('body').removeClass('menu-open');
    this.clean();
    $('#navigation-menu > nav > ul').addClass('current');
    $('#navigation-menu > nav').css('height', 'auto');
    this.ul_current = $('#navigation-menu > nav > ul');
    $('#menu').addClass('root');

}

Menu.prototype.clean = function () {
    $('#navigation-menu ul').removeClass('current animate-inFromRight animate-outToLeft animate-inFromLeft animate-outToRight');
}


/*Close Menu Desktop*/
Menu.prototype.close = function (index) {
    $('#navigation-menu > nav > ul > li').removeClass('open');
}

/*Open an element in Menu Desktop*/
Menu.prototype.open = function (index) {
    this.is_open = true;
    $('#navigation-menu > nav > ul > li').removeClass('open');
    $('#navigation-menu > nav > ul > li').eq(index).addClass('open');
};

/*Variable is menu open or not*/
Menu.prototype.is_open = false;
Menu.prototype.ul_current = null;



}).call(this,require("km4Umf"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/exports/menu.js","/exports")